import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Optional,
  Output
} from '@angular/core';

import { skyAnimationSlide } from '../../animation/slide';
import { SkyTileDashboardService } from '../tile-dashboard/tile-dashboard.service';


export class SkyTileComponent {
  public isInDashboardColumn = false;

  
  public showSettings: boolean = true;

  
  public settingsClick = new EventEmitter();

  
  public isCollapsedChange = new EventEmitter<boolean>();

  public get isCollapsed(): boolean {
    if (this.dashboardService) {
      return this.dashboardService.tileIsCollapsed(this);
    }

    return this._isCollapsed;
  }

  
  public set isCollapsed(value: boolean) {
    if (this.dashboardService) {
      this.dashboardService.setTileCollapsed(this, value);
    } else {
      this._isCollapsed = value;
    }

    this.isCollapsedChange.emit(value);
  }

  private _isCollapsed = false;

  constructor(
    public elementRef: ElementRef,
     private dashboardService: SkyTileDashboardService
  ) {
    this.isInDashboardColumn = !!dashboardService;
  }

  public settingsButtonClicked() {
    this.settingsClick.emit(undefined);
  }

  public get hasSettings(): boolean {
    return this.settingsClick.observers.length > 0 && this.showSettings;
  }

  public titleClick() {
    this.isCollapsed = !this.isCollapsed;
  }

  public chevronDirectionChange(direction: string) {
    this.isCollapsed = direction === 'down';
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tile',
  styles: [`.sky-tile {
  background-color: #fff;
  margin-bottom: 20px;
}

.sky-tile-header {
  border-color: #cdcfd2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  display: flex;
}

.sky-tile-header-content {
  display: flex;
  flex: 1;
  align-items: baseline;
  cursor: pointer;
}

.sky-tile-title {
  font-family: "Blackbaud Sans Condensed", "Helvetica Neue Condensed", "Arial Narrow";
  color: #282b31;
  font-weight: 300;
  font-size: 26px;
  margin: 0;
  padding: 10px 15px;
}

.sky-tile-summary {
  font-family: "Blackbaud Sans Condensed", "Helvetica Neue Condensed", "Arial Narrow";
  color: #282b31;
  font-weight: 500;
  font-size: 22px;
  color: #007ca6;
  opacity: 0;
  padding-right: 15px;
  transition: opacity 250ms;
  max-height: 30px;
  overflow: hidden;
}

.sky-tile-collapsed .sky-tile-summary {
  opacity: 1;
}

.sky-tile-header-column-tools {
  flex-shrink: 0;
}

.sky-tile-content {
  border-color: #e2e3e4;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}

:host /deep/ .sky-tile-tools .sky-chevron {
  margin: 12px 9px 12px 0;
}

.sky-tile-settings {
  color: #cdcfd2;
  cursor: pointer;
  height: 24px;
  margin: 12px 9px 12px 0;
  padding: 0;
  background-color: transparent;
  border: none;
  width: 24px;
}

.sky-tile-settings:hover {
  color: #979ba2;
  transition: color 150ms;
}

.sky-tile-grab-handle {
  color: #cdcfd2;
  cursor: pointer;
  cursor: move;
  cursor: -webkit-grab;
  cursor: -moz-grab;
  font-size: 15px;
  padding: 15px 15px 15px 0;
}

.sky-tile-grab-handle:hover {
  color: #979ba2;
  transition: color 150ms;
}
`],
  template: `<section
    class="sky-tile"
    [ngClass]="{
      'sky-tile-collapsed': isCollapsed
    }"
>
  <header class="sky-tile-header">
    <div class="sky-tile-header-content" (click)="titleClick()">
      <h1 class="sky-tile-title">
        <ng-content select="sky-tile-title"></ng-content>
      </h1>
      <div class="sky-tile-summary">
        <ng-content select="sky-tile-summary"></ng-content>
      </div>
    </div>
    <div class="sky-tile-header-column-tools">
      <div class="sky-tile-tools">
        <sky-chevron
            [direction]="isCollapsed ? 'down' : 'up'"
            (directionChange)="chevronDirectionChange($event)"
        >
        </sky-chevron>
        <button
            type="button"
            *ngIf="hasSettings"
            class="sky-tile-settings fa fa-cog"
            [attr.aria-label]="'tile_settings' | skyResources"
            (click)="settingsButtonClicked();"
        >
        </button>
        <i
            class="sky-tile-grab-handle fa fa-th"
            *ngIf="isInDashboardColumn"
        >
        </i>
      </div>
    </div>
  </header>
  <div class="sky-tile-content" [@skyAnimationSlide]="isCollapsed ? 'up' : 'down'">
    <ng-content select="sky-tile-content"></ng-content>
  </div>
</section>
`,
  animations: [skyAnimationSlide]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: SkyTileDashboardService, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'showSettings': [{ type: Input },],
'settingsClick': [{ type: Output },],
'isCollapsedChange': [{ type: Output },],
'isCollapsed': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
